import {
  List, ListItem, ListItemText, Typography,Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: '60vh'
  },
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  }
}));

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

function NotificationList({
  notifications,
  onClickNotification,
  className,
  ...rest
}) {
  const classes = useStyles();

  const getTitle = (event, Title, InsertDate) => {
    return (
      <Typography color="primary" variant="h6">
        <span style={{ fontWeight: 'bold' }}>{Title}</span> 
        <span style={{ fontSize: 'small', fontWeight: 'normal' }}> {bull} {InsertDate}</span>
      </Typography>
    );
  };
  return (
    <List {...rest} className={clsx(classes.root, className)} disablePadding>
    {notifications.map(not => (
    <div key={not.Id}>
    <ListItem style={{backgroundColor: not.IsRead === true ? 'transparent' : '#f1f1f1' }}
      className={classes.listItem}
      divider={not < notifications.length - 1}
      key={not.Id}
    >
      <ListItemText 
        primary={getTitle(not, not.NotificationHeader,not.InsertDate)}
        primaryTypographyProps={{ variant: 'body1' }}
        secondary={
          <>
            <Typography
              component="span"
              variant="body2"
              className={classes.inline}
              color="textPrimary"
            >
              {not.NotificationBody}
            </Typography>
          </>
        }
      />
    </ListItem>
    </div>
    ))}
  </List>
  );
}

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired,
  onClickNotification: PropTypes.func
};

export default NotificationList;
